import { StoryChapter, Choice } from '../types/dualStory';

// 模拟API延迟
const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

// 故事数据
const storyData: { [key: string]: StoryChapter[] } = {
  '1': [
    {
      id: '1-1',
      title: '第一章：紧急报案',
      content: '派出所的电话突然响起，接线员的声音听起来很焦急："喂，警察同志吗？我父亲正在邮寄金条给什么仙师，我们怎么劝都劝不住！"',
      speaker: '接线员',
      timeline: 'modern',
      choices: [
        { id: '1-1-a', text: '立即出警阻止', nextChapter: '1-2' },
        { id: '1-1-b', text: '先了解更多情况', nextChapter: '1-3' }
      ]
    },
    {
      id: '1-2',
      title: '第二章：争分夺秒',
      content: '警车鸣着警笛飞驰在市区街道上。老张警官握着方向盘，心里不断祈祷："希望还来得及..."',
      speaker: '旁白',
      timeline: 'modern',
      choices: [
        { id: '1-2-a', text: '直接赶到快递点', nextChapter: '1-4' },
        { id: '1-2-b', text: '先联系快递公司拦截', nextChapter: '1-5' }
      ]
    },
    {
      id: '1-3',
      title: '第二章：深入了解',
      content: '接线员继续说道："我父亲叫王大爷，今年72岁。最近加入了一个投资群，群里有个所谓的仙师，说能卖长生不老仙丹..."',
      speaker: '接线员',
      timeline: 'modern',
      choices: [
        { id: '1-3-a', text: '询问详细地址', nextChapter: '1-4' },
        { id: '1-3-b', text: '询问对方联系方式', nextChapter: '1-5' }
      ]
    },
    {
      id: '1-4',
      title: '第三章：快递点对峙',
      content: '快递点里，王大爷正固执地打包着金条。"你们别管我！仙师说了，这仙丹能让我活到150岁！"',
      speaker: '王大爷',
      timeline: 'modern',
      choices: [
        { id: '1-4-a', text: '耐心劝说', nextChapter: '1-6' },
        { id: '1-4-b', text: '联系其子女', nextChapter: '1-7' }
      ]
    },
    {
      id: '1-5',
      title: '第三章：拦截行动',
      content: '快递公司客服："确实有一个包裹，正准备派送。收件地址是城郊的废弃仓库！"',
      speaker: '快递客服',
      timeline: 'modern',
      choices: [
        { id: '1-5-a', text: '立即前往仓库', nextChapter: '1-8' },
        { id: '1-5-b', text: '请求支援包围', nextChapter: '1-9' }
      ]
    },
    {
      id: '1-6',
      title: '第四章：苦口婆心',
      content: '老张警官温和地说："大爷，您想想，真有仙丹怎么会需要金条买？这是典型的电信诈骗！"',
      speaker: '老张警官',
      timeline: 'modern',
      choices: [
        { id: '1-6-a', text: '展示诈骗案例', nextChapter: '1-10' },
        { id: '1-6-b', text: '联系家属共同劝说', nextChapter: '1-11' }
      ]
    },
    {
      id: '1-7',
      title: '第四章：家人团聚',
      content: '王大爷的儿子赶到现场："爸！您醒醒吧，哪有什么仙师，这都是骗子！"',
      speaker: '儿子',
      timeline: 'modern',
      choices: [
        { id: '1-7-a', text: '讲述诈骗手法', nextChapter: '1-12' },
        { id: '1-7-b', text: '报警处理', nextChapter: '1-13' }
      ]
    },
    {
      id: '1-8',
      title: '第四章：废弃仓库',
      content: '废弃仓库里空无一人，只有几个打包好的快递盒。老张警官意识到："这是个陷阱！他们根本不在这里见面！"',
      speaker: '老张警官',
      timeline: 'modern',
      choices: [
        { id: '1-8-a', text: '检查快递盒', nextChapter: '1-14' },
        { id: '1-8-b', text: '调取监控录像', nextChapter: '1-15' }
      ]
    },
    {
      id: '1-9',
      title: '第四章：收网行动',
      content: '特警队包围了仓库。"警察都不许动！举起手来！"几个正在分赃的骗子束手就擒。',
      speaker: '特警队长',
      timeline: 'modern',
      choices: [
        { id: '1-9-a', text: '审问主犯', nextChapter: '1-16' },
        { id: '1-9-b', text: '查找受害者', nextChapter: '1-17' }
      ]
    },
    {
      id: '1-10',
      title: '第五章：真相大白',
      content: '老张警官拿出手机："您看，这就是那个所谓的仙师，上周刚被抓了！专骗老年人！"',
      speaker: '老张警官',
      timeline: 'modern',
      choices: [
        { id: '1-10-a', text: '王大爷醒悟', nextChapter: '1-18' },
        { id: '1-10-b', text: '仍不相信', nextChapter: '1-19' }
      ]
    },
    {
      id: '1-11',
      title: '第五章：亲情的力量',
      content: '儿子跪在地上："爸，我跟妈都担心您死了！那些骗子就是看我们工作忙，专门骗您这种老人！"',
      speaker: '儿子',
      timeline: 'modern',
      choices: [
        { id: '1-11-a', text: '王大爷感动', nextChapter: '1-18' },
        { id: '1-11-b', text: '继续固执', nextChapter: '1-19' }
      ]
    },
    {
      id: '1-12',
      title: '第五章：揭秘骗局',
      content: '儿子解释道："他们先给您一点小甜头，说能治好您的老寒腿，等您信了就开始要钱了！"',
      speaker: '儿子',
      timeline: 'modern',
      choices: [
        { id: '1-12-a', text: '展示转账记录', nextChapter: '1-18' },
        { id: '1-12-b', text: '联系其他受害者', nextChapter: '1-20' }
      ]
    },
    {
      id: '1-13',
      title: '第五章：法网恢恢',
      content: '派出所里，民警记录："王大爷，您已经被骗了20万。我们会立案侦查，尽力追回您的钱款。"',
      speaker: '民警',
      timeline: 'modern',
      choices: [
        { id: '1-13-a', text: '提供线索', nextChapter: '1-21' },
        { id: '1-13-b', text: '情绪崩溃', nextChapter: '1-22' }
      ]
    },
    {
      id: '1-18',
      title: '结局：幡然醒悟',
      content: '王大爷终于明白了："我真是老糊涂了！差点把养老钱都给骗子！谢谢你们！"',
      speaker: '王大爷',
      timeline: 'modern',
      choices: []
    },
    {
      id: '1-19',
      title: '结局：执迷不悟',
      content: '王大爷仍然坚持："我不信！仙师说了，只要心诚，仙丹一定会来的！你们都是凡人，不懂！"',
      speaker: '王大爷',
      timeline: 'modern',
      choices: []
    }
  ],
  '2': [
    {
      id: '2-1',
      title: '第一章：江南富商',
      content: '明朝南京城，富商沈万三府邸。"老爷，城外破庙的道士说有皇家秘制的仙丹，只要金条换取！"',
      speaker: '管家',
      timeline: 'ancient',
      choices: [
        { id: '2-1-a', text: '立即前往查看', nextChapter: '2-2' },
        { id: '2-1-b', text: '派人先打探', nextChapter: '2-3' }
      ]
    },
    {
      id: '2-2',
      title: '第二章：破庙相见',
      content: '破庙里，一个道士模样的人正在打坐。"贫道乃蓬莱仙师，得真人真传，有延年益寿之仙丹。"',
      speaker: '假道士',
      timeline: 'ancient',
      choices: [
        { id: '2-2-a', text: '要求展示仙丹', nextChapter: '2-4' },
        { id: '2-2-b', text: '询问价格', nextChapter: '2-5' }
      ]
    },
    {
      id: '2-3',
      title: '第二章：暗中调查',
      content: '管家回报："老爷，那道士自称来自武当，但本地人都没见过他。而且最近有好几位富商都去找过他。"',
      speaker: '管家',
      timeline: 'ancient',
      choices: [
        { id: '2-3-a', text: '询问其他富商', nextChapter: '2-6' },
        { id: '2-3-b', text: '报官处理', nextChapter: '2-7' }
      ]
    },
    {
      id: '2-4',
      title: '第三章：仙丹真相',
      content: '道士拿出一个精致的瓷瓶："此乃九转金丹，服用一枚可增寿一纪。只需十根金条即可。"',
      speaker: '假道士',
      timeline: 'ancient',
      choices: [
        { id: '2-4-a', text: '要求先试用', nextChapter: '2-8' },
        { id: '2-4-b', text: '请太医鉴定', nextChapter: '2-9' }
      ]
    },
    {
      id: '2-5',
      title: '第三章：天价仙丹',
      content: '"仙丹分三等，上等增寿三十年，需金条百根；中等二十年，五十根；下等十年，二十根。"',
      speaker: '假道士',
      timeline: 'ancient',
      choices: [
        { id: '2-5-a', text: '讨价还价', nextChapter: '2-10' },
        { id: '2-5-b', text: '放弃购买', nextChapter: '2-11' }
      ]
    },
    {
      id: '2-6',
      title: '第三章：富商联盟',
      content: '张员外叹气："沈兄，我上个月买了十根金条的仙丹，吃下去拉了三天肚子！"',
      speaker: '张员外',
      timeline: 'ancient',
      choices: [
        { id: '2-6-a', text: '质问道士', nextChapter: '2-12' },
        { id: '2-6-b', text: '报官处理', nextChapter: '2-13' }
      ]
    },
    {
      id: '2-7',
      title: '第三章：官府介入',
      content: '应天府知府："本府已接到多起报案，必当严查此等妖言惑众之徒！"',
      speaker: '知府大人',
      timeline: 'ancient',
      choices: [
        { id: '2-7-a', text: '配合调查', nextChapter: '2-14' },
        { id: '2-7-b', text: '私下了结', nextChapter: '2-15' }
      ]
    },
    {
      id: '2-8',
      title: '第四章：仙丹试吃',
      content: '道士拿出一粒黑乎乎的药丸："此乃贫道炼制的驻颜丹，沈富商请尝一尝。"',
      speaker: '假道士',
      timeline: 'ancient',
      choices: [
        { id: '2-8-a', text: '让仆人先试', nextChapter: '2-16' },
        { id: '2-8-b', text: '自己品尝', nextChapter: '2-17' }
      ]
    },
    {
      id: '2-9',
      title: '第四章：太医鉴定',
      content: '太医仔细查看后禀报："老爷，此乃普通的蜂蜜丸子，加了些香料而已！"',
      speaker: '太医',
      timeline: 'ancient',
      choices: [
        { id: '2-9-a', text: '揭穿骗子', nextChapter: '2-18' },
        { id: '2-9-b', text: '将计就计', nextChapter: '2-19' }
      ]
    },
    {
      id: '2-10',
      title: '第四章：讨价还价',
      content: '沈万三说："十根金条太贵了！五根如何？毕竟长生无价，但也要讲个缘分。"',
      speaker: '沈万三',
      timeline: 'ancient',
      choices: [
        { id: '2-10-a', text: '道士同意', nextChapter: '2-20' },
        { id: '2-10-b', text: '道士拒绝', nextChapter: '2-21' }
      ]
    },
    {
      id: '2-11',
      title: '第四章：悬崖勒马',
      content: '沈万三想了想："算了，我还是相信钱庄的银票比较实在。仙丹之事，改日再说。"',
      speaker: '沈万三',
      timeline: 'ancient',
      choices: [
        { id: '2-11-a', text: '暗中观察', nextChapter: '2-22' },
        { id: '2-11-b', text: '彻底放弃', nextChapter: '2-23' }
      ]
    },
    {
      id: '2-18',
      title: '结局：骗局败露',
      content: '假道士见势不妙想要逃跑，被家丁按倒在地："饶命！小的也是骗人吃饭啊！"',
      speaker: '假道士',
      timeline: 'ancient',
      choices: []
    },
    {
      id: '2-19',
      title: '结局：将计就计',
      content: '沈万三假装上当："既然仙丹如此神奇，我买一百根！请道长明日府上详谈！"',
      speaker: '沈万三',
      timeline: 'ancient',
      choices: []
    }
  ],
  '12': [
    {
      id: '12-1',
      title: '第一章：派出所的宁静',
      content: '王大爷疲惫地靠在派出所的椅子上，笔录已经做完了。窗外的月光透过铁栏杆洒进来，在地板上留下斑驳的影子。',
      speaker: '旁白',
      timeline: 'final',
      choices: [
        { id: '12-1-a', text: '闭上眼睛休息', nextChapter: '12-2' },
        { id: '12-1-b', text: '回想刚才的经历', nextChapter: '12-3' }
      ]
    },
    {
      id: '12-2',
      title: '第二章：恍惚之间',
      content: '王大爷的眼皮越来越重，恍惚间，他看到了另一个自己——身着锦衣的古代富商，正对着铜镜唉声叹气。',
      speaker: '旁白',
      timeline: 'final',
      choices: [
        { id: '12-2-a', text: '走向镜中的自己', nextChapter: '12-4' },
        { id: '12-2-b', text: '仔细观察周围', nextChapter: '12-5' }
      ]
    },
    {
      id: '12-3',
      title: '第二章：记忆回溯',
      content: '电话铃声、警察的询问、骗子的话术...一幕幕在王大爷脑海中闪现。他突然意识到，自己差点就失去了所有养老钱。',
      speaker: '旁白',
      timeline: 'final',
      choices: [
        { id: '12-3-a', text: '感到后怕', nextChapter: '12-6' },
        { id: '12-3-b', text: '感到庆幸', nextChapter: '12-7' }
      ]
    },
    {
      id: '12-4',
      title: '第三章：镜中人',
      content: '镜中的富商转过身来，竟然和王大爷长得一模一样！"贤弟，你也被那个所谓的仙师骗了？"',
      speaker: '古代富商',
      timeline: 'final',
      choices: [
        { id: '12-4-a', text: '询问对方身份', nextChapter: '12-8' },
        { id: '12-4-b', text: '询问仙丹之事', nextChapter: '12-9' }
      ]
    },
    {
      id: '12-5',
      title: '第三章：派出所的变化',
      content: '周围的环境开始变化，白色的墙壁变成了古朴的木质结构，电脑变成了文房四宝。',
      speaker: '旁白',
      timeline: 'final',
      choices: [
        { id: '12-5-a', text: '探索这个新世界', nextChapter: '12-10' },
        { id: '12-5-b', text: '寻找回去的路', nextChapter: '12-11' }
      ]
    },
    {
      id: '12-6',
      title: '第三章：人性的贪婪',
      content: '王大爷想起自己为什么会相信骗子——因为害怕死亡，因为想要长生。这种贪婪，骗子利用得恰到好处。',
      speaker: '内心独白',
      timeline: 'final',
      choices: [
        { id: '12-6-a', text: '深刻反思', nextChapter: '12-12' },
        { id: '12-6-b', text: '难以释怀', nextChapter: '12-13' }
      ]
    },
    {
      id: '12-7',
      title: '第三章：警钟长鸣',
      content: '"幸好警察同志及时赶到..."王大爷喃喃自语。他意识到，如果不是警察，自己的晚年就毁了。',
      speaker: '王大爷',
      timeline: 'final',
      choices: [
        { id: '12-7-a', text: '感谢警察', nextChapter: '12-14' },
        { id: '12-7-b', text: '反思自己', nextChapter: '12-15' }
      ]
    },
    {
      id: '12-8',
      title: '第四章：古今对话',
      content: '"在下沈万三，"富商作揖道，"被那假道士骗了百根金条。贤弟你呢？"',
      speaker: '古代富商',
      timeline: 'final',
      choices: [
        { id: '12-8-a', text: '讲述自己的经历', nextChapter: '12-16' },
        { id: '12-8-b', text: '安慰对方', nextChapter: '12-17' }
      ]
    },
    {
      id: '12-9',
      title: '第四章：仙丹的真相',
      content: '"那仙丹不过是蜂蜜丸子，"富商叹道，"但我们这些想要长生的人，却愿意相信它是真的。"',
      speaker: '古代富商',
      timeline: 'final',
      choices: [
        { id: '12-9-a', text: '感慨人性', nextChapter: '12-18' },
        { id: '12-9-b', text: '询问结局', nextChapter: '12-19' }
      ]
    },
    {
      id: '12-10',
      title: '第四章：时空交错',
      content: '现代的派出所与古代的书房融为一体，电话铃声与古筝声交织，形成奇妙的交响。',
      speaker: '旁白',
      timeline: 'final',
      choices: [
        { id: '12-10-a', text: '接受现实', nextChapter: '12-20' },
        { id: '12-10-b', text: '寻找真相', nextChapter: '12-21' }
      ]
    },
    {
      id: '12-11',
      title: '第四章：回归之路',
      content: '王大爷意识到，这可能只是一个梦。但这个梦，却让他看清了很多事情。',
      speaker: '旁白',
      timeline: 'final',
      choices: [
        { id: '12-11-a', text: '迎接醒来', nextChapter: '12-22' },
        { id: '12-11-b', text: '继续探索', nextChapter: '12-23' }
      ]
    },
    {
      id: '12-12',
      title: '结局：醒悟',
      content: '王大爷明白了：骗子利用的不是愚蠢，而是人性固有的弱点。贪婪、恐惧、孤独，这些每个人都会有。',
      speaker: '内心独白',
      timeline: 'final',
      choices: []
    },
    {
      id: '12-13',
      title: '结局：释然',
      content: '"吃一堑长一智，"王大爷苦笑道，"至少我现在明白了，天上不会掉馅饼，只会掉陷阱。"',
      speaker: '王大爷',
      timeline: 'final',
      choices: []
    },
    {
      id: '12-14',
      title: '结局：感恩',
      content: '王大爷决定，以后要用自己的经历告诫其他老年人，不要重蹈覆辙。',
      speaker: '旁白',
      timeline: 'final',
      choices: []
    },
    {
      id: '12-15',
      title: '结局：重生',
      content: '这次经历让王大爷成长了。他学会了理性思考，学会了怀疑，学会了保护自己。',
      speaker: '旁白',
      timeline: 'final',
      choices: []
    },
    {
      id: '12-16',
      title: '结局：共鸣',
      content: '"原来古今都一样，"王大爷感慨道，"骗子换汤不换药，但我们这些普通人，却总是上当。"',
      speaker: '王大爷',
      timeline: 'final',
      choices: []
    },
    {
      id: '12-17',
      title: '结局：传承',
      content: '沈万三说："贤弟，我们的经历，要告诉后人啊。让他们知道，贪婪是万恶之源。"',
      speaker: '古代富商',
      timeline: 'final',
      choices: []
    },
    {
      id: '12-18',
      title: '结局：智慧',
      content: '王大爷和沈万三相视一笑，虽然相隔数百年，但他们对人性的理解却是相通的。',
      speaker: '旁白',
      timeline: 'final',
      choices: []
    },
    {
      id: '12-19',
      title: '结局：轮回',
      content: '"历史总是惊人的相似，"王大爷说道，"但愿后人能从我们的经历中学到什么。"',
      speaker: '王大爷',
      timeline: 'final',
      choices: []
    },
    {
      id: '12-20',
      title: '结局：融合',
      content: '现代与古代在王大爷的脑海中融合，他突然明白了：时代在变，但人心不变。',
      speaker: '旁白',
      timeline: 'final',
      choices: []
    },
    {
      id: '12-21',
      title: '结局：顿悟',
      content: '"原来如此！"王大爷惊醒，"这只是一个梦，但这个梦，让我看清了真相。"',
      speaker: '王大爷',
      timeline: 'final',
      choices: []
    },
    {
      id: '12-22',
      title: '结局：现实',
      content: '急促的手机铃声将王大爷拉回现实。原来是他的儿子打来的，问他什么时候回家。',
      speaker: '旁白',
      timeline: 'final',
      choices: []
    },
    {
      id: '12-23',
      title: '结局：新生',
      content: '王大爷睁开眼睛，发现自己还在派出所。但这一次，他的内心已经完全不同了。',
      speaker: '旁白',
      timeline: 'final',
      choices: []
    }
  ],
  'dual-insight': [
    {
      id: 'insight-1',
      title: '第一章：夜话',
      content: '夜深了，警局里只剩下师徒两人。陆鸣放下手中的卷宗："师傅，处理了这么多案子，我发现骗子的手法其实都差不多。"',
      speaker: '陆鸣',
      timeline: 'final',
      choices: [
        { id: 'insight-1-a', text: '他们都在利用人性的弱点', nextChapter: 'insight-2' }
      ]
    },
    {
      id: 'insight-2',
      title: '第二章：本质',
      content: '老韩呷了口茶："没错。无论是古代的炼丹术士，还是现在的网络诈骗，本质上都是利用了人的贪婪和恐惧。"',
      speaker: '老韩',
      timeline: 'final',
      choices: [
        { id: 'insight-2-a', text: '那我们该如何防范？', nextChapter: 'insight-3' }
      ]
    },
    {
      id: 'insight-3',
      title: '第三章：守护',
      content: '记住，我们的责任不仅是破案，更是守护。守护好每一个可能受骗的心灵。这，就是警察的使命。"',
      speaker: '老韩',
      timeline: 'final',
      choices: [
        { id: 'insight-3-a', text: '我明白了', nextChapter: 'insight-4' }
      ]
    },
    {
      id: 'insight-4',
      title: '第四章：传承',
      content: '你已深刻理解了反诈工作的真谛。\n\n时代在变，但守护初心的使命永远不变。\n\n愿你能成为那道光，照亮他人前行的路。',
      speaker: '系统',
      timeline: 'final',
      choices: []
    }
  ],
  '11': [
    {
      id: '11-1',
      title: '第一章：派出所的宁静',
      content: '王大爷疲惫地靠在派出所的椅子上，笔录已经做完了。窗外的月光透过铁栏杆洒进来，在地板上留下斑驳的影子。',
      speaker: '旁白',
      timeline: 'final',
      choices: [
        { id: '11-1-a', text: '闭上眼睛休息', nextChapter: '11-2' },
        { id: '11-1-b', text: '回想刚才的经历', nextChapter: '11-3' }
      ]
    },
    {
      id: '11-2',
      title: '第二章：恍惚之间',
      content: '王大爷的眼皮越来越重，恍惚间，他看到了另一个自己——身着锦衣的古代富商，正对着铜镜唉声叹气。',
      speaker: '旁白',
      timeline: 'final',
      choices: [
        { id: '11-2-a', text: '走向镜中的自己', nextChapter: '11-4' },
        { id: '11-2-b', text: '仔细观察周围', nextChapter: '11-5' }
      ]
    },
    {
      id: '11-3',
      title: '第二章：记忆回溯',
      content: '电话铃声、警察的询问、骗子的话术...一幕幕在王大爷脑海中闪现。他突然意识到，自己差点就失去了所有养老钱。',
      speaker: '旁白',
      timeline: 'final',
      choices: [
        { id: '11-3-a', text: '感到后怕', nextChapter: '11-6' },
        { id: '11-3-b', text: '感到庆幸', nextChapter: '11-7' }
      ]
    },
    {
      id: '11-4',
      title: '第三章：镜中人',
      content: '镜中的富商转过身来，竟然和王大爷长得一模一样！"贤弟，你也被那个所谓的仙师骗了？"',
      speaker: '古代富商',
      timeline: 'final',
      choices: [
        { id: '11-4-a', text: '询问对方身份', nextChapter: '11-8' },
        { id: '11-4-b', text: '询问仙丹之事', nextChapter: '11-9' }
      ]
    },
    {
      id: '11-5',
      title: '第三章：派出所的变化',
      content: '周围的环境开始变化，白色的墙壁变成了古朴的木质结构，电脑变成了文房四宝。',
      speaker: '旁白',
      timeline: 'final',
      choices: [
        { id: '11-5-a', text: '探索这个新世界', nextChapter: '11-10' },
        { id: '11-5-b', text: '寻找回去的路', nextChapter: '11-11' }
      ]
    },
    {
      id: '11-6',
      title: '第三章：人性的贪婪',
      content: '王大爷想起自己为什么会相信骗子——因为害怕死亡，因为想要长生。这种贪婪，骗子利用得恰到好处。',
      speaker: '内心独白',
      timeline: 'final',
      choices: [
        { id: '11-6-a', text: '深刻反思', nextChapter: '11-12' },
        { id: '11-6-b', text: '难以释怀', nextChapter: '11-13' }
      ]
    },
    {
      id: '11-7',
      title: '第三章：警钟长鸣',
      content: '"幸好警察同志及时赶到..."王大爷喃喃自语。他意识到，如果不是警察，自己的晚年就毁了。',
      speaker: '王大爷',
      timeline: 'final',
      choices: [
        { id: '11-7-a', text: '感谢警察', nextChapter: '11-14' },
        { id: '11-7-b', text: '反思自己', nextChapter: '11-15' }
      ]
    },
    {
      id: '11-8',
      title: '第四章：古今对话',
      content: '"在下沈万三，"富商作揖道，"被那假道士骗了百根金条。贤弟你呢？"',
      speaker: '古代富商',
      timeline: 'final',
      choices: [
        { id: '11-8-a', text: '讲述自己的经历', nextChapter: '11-16' },
        { id: '11-8-b', text: '安慰对方', nextChapter: '11-17' }
      ]
    },
    {
      id: '11-9',
      title: '第四章：仙丹的真相',
      content: '"那仙丹不过是蜂蜜丸子，"富商叹道，"但我们这些想要长生的人，却愿意相信它是真的。"',
      speaker: '古代富商',
      timeline: 'final',
      choices: [
        { id: '11-9-a', text: '感慨人性', nextChapter: '11-18' },
        { id: '11-9-b', text: '询问结局', nextChapter: '11-19' }
      ]
    },
    {
      id: '11-10',
      title: '第四章：时空交错',
      content: '现代的派出所与古代的书房融为一体，电话铃声与古筝声交织，形成奇妙的交响。',
      speaker: '旁白',
      timeline: 'final',
      choices: [
        { id: '11-10-a', text: '接受现实', nextChapter: '11-20' },
        { id: '11-10-b', text: '寻找真相', nextChapter: '11-21' }
      ]
    },
    {
      id: '11-11',
      title: '第四章：回归之路',
      content: '王大爷意识到，这可能只是一个梦。但这个梦，却让他看清了很多事情。',
      speaker: '旁白',
      timeline: 'final',
      choices: [
        { id: '11-11-a', text: '迎接醒来', nextChapter: '11-22' },
        { id: '11-11-b', text: '继续探索', nextChapter: '11-23' }
      ]
    },
    {
      id: '11-12',
      title: '结局：醒悟',
      content: '王大爷明白了：骗子利用的不是愚蠢，而是人性固有的弱点。贪婪、恐惧、孤独，这些每个人都会有。',
      speaker: '内心独白',
      timeline: 'final',
      choices: []
    },
    {
      id: '11-13',
      title: '结局：释然',
      content: '"吃一堑长一智，"王大爷苦笑道，"至少我现在明白了，天上不会掉馅饼，只会掉陷阱。"',
      speaker: '王大爷',
      timeline: 'final',
      choices: []
    },
    {
      id: '11-14',
      title: '结局：感恩',
      content: '王大爷决定，以后要用自己的经历告诫其他老年人，不要重蹈覆辙。',
      speaker: '旁白',
      timeline: 'final',
      choices: []
    },
    {
      id: '11-15',
      title: '结局：重生',
      content: '这次经历让王大爷成长了。他学会了理性思考，学会了怀疑，学会了保护自己。',
      speaker: '旁白',
      timeline: 'final',
      choices: []
    },
    {
      id: '11-16',
      title: '结局：共鸣',
      content: '"原来古今都一样，"王大爷感慨道，"骗子换汤不换药，但我们这些普通人，却总是上当。"',
      speaker: '王大爷',
      timeline: 'final',
      choices: []
    },
    {
      id: '11-17',
      title: '结局：传承',
      content: '沈万三说："贤弟，我们的经历，要告诉后人啊。让他们知道，贪婪是万恶之源。"',
      speaker: '古代富商',
      timeline: 'final',
      choices: []
    },
    {
      id: '11-18',
      title: '结局：智慧',
      content: '王大爷和沈万三相视一笑，虽然相隔数百年，但他们对人性的理解却是相通的。',
      speaker: '旁白',
      timeline: 'final',
      choices: []
    },
    {
      id: '11-19',
      title: '结局：轮回',
      content: '"历史总是惊人的相似，"王大爷说道，"但愿后人能从我们的经历中学到什么。"',
      speaker: '王大爷',
      timeline: 'final',
      choices: []
    },
    {
      id: '11-20',
      title: '结局：融合',
      content: '现代与古代在王大爷的脑海中融合，他突然明白了：时代在变，但人心不变。',
      speaker: '旁白',
      timeline: 'final',
      choices: []
    },
    {
      id: '11-21',
      title: '结局：顿悟',
      content: '"原来如此！"王大爷惊醒，"这只是一个梦，但这个梦，让我看清了真相。"',
      speaker: '王大爷',
      timeline: 'final',
      choices: []
    },
    {
      id: '11-22',
      title: '结局：现实',
      content: '急促的手机铃声将王大爷拉回现实。原来是他的儿子打来的，问他什么时候回家。',
      speaker: '旁白',
      timeline: 'final',
      choices: []
    },
    {
      id: '11-23',
      title: '结局：新生',
      content: '王大爷睁开眼睛，发现自己还在派出所。但这一次，他的内心已经完全不同了。',
      speaker: '旁白',
      timeline: 'final',
      choices: []
    }
  ]
};

// 获取故事列表
export const getDualStories = async () => {
  await delay(500);

  const stories = [
    {
      id: '1',
      surface: '现代篇：王大爷坚持要邮寄10根金条给"仙师"，警察赶到时他正在打包。',
      truth: '王大爷是电信诈骗受害者...',
      timeline: 'modern' as const,
      difficulty: '中等',
      tags: ['诈骗', '老年人受害', '电信诈骗'],
      category: '推理',
      victory_condition: '猜出王大爷为什么执着于邮寄金条',
      additional: '法律知识点：诈骗罪是指...',
      unlocked: true,
    },
    {
      id: '2',
      surface: '古代篇：富商沈万三不愿通过钱庄兑换银票，坚持要用金条向道士购买"仙丹"。',
      truth: '沈万三被假道士欺骗...',
      timeline: 'ancient' as const,
      difficulty: '中等',
      tags: ['诈骗', '迷信', '锦衣卫'],
      category: '推理',
      victory_condition: '猜出沈万三为何冒险用金条交易',
      additional: '法律知识点：《大明律》规定...',
      unlocked: true,
    },
    {
      id: '12',
      surface: '大梦初醒',
      truth: '经历了现代与古代的双重骗局后，王大爷终于明白了骗局的本质。',
      timeline: 'final' as const,
      difficulty: '中等',
      tags: ['双线叙事', '元剧情', '普法教育'],
      category: '双线叙事',
      victory_condition: '理解整个双线叙事的寓意',
      additional: '法律知识点：电信网络诈骗犯罪...',
      unlocked: false,
    },
    {
      id: 'dual-insight',
      surface: '古今人性：不变的弱点',
      truth: '通过深入的对话，探讨古今诈骗中不变的人性弱点。',
      timeline: 'final' as const,
      difficulty: '5-10分钟',
      tags: ['人性探讨', '深度思考', '警民对话'],
      category: '对话互动',
      victory_condition: '深刻理解反诈工作的真谛',
      additional: '时代在变，但守护初心的使命永远不变。',
      unlocked: false,
    }
  ];

  // 检查完成状态
  const savedProgress = JSON.parse(localStorage.getItem('dualStoryProgress') || '{}');
  const completedStories = savedProgress.completedStories || savedProgress.completed || [];

  return stories.map(story => {
    let updatedStory = {
      ...story,
      completed: completedStories.includes(story.id)
    };

    // 如果是王大爷故事，检查现代线和古代线是否都已完成
    if (story.id === '12') {
      const modernCompleted = completedStories.includes('1');
      const ancientCompleted = completedStories.includes('2');
      updatedStory.unlocked = modernCompleted && ancientCompleted;
    }
    // 如果是古今人性故事，检查王大爷故事是否已完成
    else if (story.id === 'dual-insight') {
      const wangCompleted = completedStories.includes('12');
      updatedStory.unlocked = wangCompleted;
    }

    return updatedStory;
  });
};

// 获取故事章节
export const getStoryChapters = async (storyId: string) => {
  await delay(300);
  return storyData[storyId] || [];
};

// 获取单个章节
export const getChapterById = async (storyId: string, chapterId: string) => {
  await delay(200);
  const chapters = storyData[storyId] || [];
  return chapters.find(ch => ch.id === chapterId);
};

// 保存进度
export const saveProgress = (storyId: string, progress: any) => {
  const savedProgress = JSON.parse(localStorage.getItem('dualStoryProgress') || '{}');
  savedProgress[storyId] = progress;
  localStorage.setItem('dualStoryProgress', JSON.stringify(savedProgress));
};

// 获取进度
export const getProgress = (storyId: string) => {
  const savedProgress = JSON.parse(localStorage.getItem('dualStoryProgress') || '{}');
  return savedProgress[storyId];
};

// 标记故事完成
export const markStoryCompleted = (storyId: string) => {
  const savedProgress = JSON.parse(localStorage.getItem('dualStoryProgress') || '{}');

  // 确保两个数组都存在
  if (!savedProgress.completed) {
    savedProgress.completed = [];
  }
  if (!savedProgress.completedStories) {
    savedProgress.completedStories = [];
  }

  // 同时更新两个数组
  if (!savedProgress.completed.includes(storyId)) {
    savedProgress.completed.push(storyId);
  }
  if (!savedProgress.completedStories.includes(storyId)) {
    savedProgress.completedStories.push(storyId);
  }

  localStorage.setItem('dualStoryProgress', JSON.stringify(savedProgress));
};

// 检查故事是否已完成
export const isStoryCompleted = (storyId: string) => {
  const savedProgress = JSON.parse(localStorage.getItem('dualStoryProgress') || '{}');
  const completed = savedProgress.completed || [];
  const completedStories = savedProgress.completedStories || [];
  return completed.includes(storyId) || completedStories.includes(storyId);
};